import React from 'react';
import { Outlet } from 'react-router-dom';

const LoginInformation: React.FC = () => {
  return <Outlet />;
};

export default LoginInformation;
